import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(t("success"));
      navigate("/dashboard");
    } else {
      toast.error(res.error || t("error"));
    }
  }

  return (
    <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:flex flex-col justify-between p-12 border-r border-zinc-200 bg-zinc-50">
        <div>
          <span className="eyebrow">A1 — Auth</span>
          <h2 className="hero-display text-6xl mt-6">DocuConvert.</h2>
          <p className="mt-6 text-zinc-600 font-light max-w-md">{t("tagline")}</p>
        </div>
        <div className="text-xs text-zinc-400 tracking-wider uppercase">© DocuConvert</div>
      </div>

      <div className="grid place-items-center p-8">
        <form onSubmit={onSubmit} className="w-full max-w-md fade-up">
          <span className="eyebrow">{t("auth_login_title")}</span>
          <h1 className="hero-h2 text-3xl sm:text-4xl mt-2">{t("auth_login_title")}</h1>
          <p className="text-zinc-500 mt-2 text-sm">{t("auth_login_sub")}</p>

          <div className="mt-8 grid gap-5">
            <div className="grid gap-2">
              <Label htmlFor="email" className="eyebrow">{t("auth_email")}</Label>
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="rounded-sm border-zinc-300 focus-visible:ring-black h-11"
                data-testid="login-email"
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="password" className="eyebrow">{t("auth_password")}</Label>
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="rounded-sm border-zinc-300 focus-visible:ring-black h-11"
                data-testid="login-password"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="rounded-sm bg-black text-white hover:bg-zinc-800 h-11"
              data-testid="login-submit"
            >
              {loading ? t("auth_loading") : t("cta_login")}
            </Button>
          </div>

          <p className="mt-6 text-sm text-zinc-500">
            {t("auth_no_account")}{" "}
            <Link to="/register" className="text-black underline underline-offset-4" data-testid="link-register">
              {t("cta_register")}
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
